export default __webpack_public_path__ + "static/ai_vertical_eng-46025d75128abe774d2879edc541c2c4.png";